"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FAVOURITE_BOX_APP = "mutation favouriteBoxApp($appId: ID!) {\n  favouriteBoxApp(appId: $appId)\n}";
exports.default = FAVOURITE_BOX_APP;
//# sourceMappingURL=favouriteBoxApp.js.map